import { render, staticRenderFns } from "./LocationDetails.vue?vue&type=template&id=c395077a&scoped=true"
import script from "./LocationDetails.vue?vue&type=script&lang=ts"
export * from "./LocationDetails.vue?vue&type=script&lang=ts"
import style0 from "./LocationDetails.vue?vue&type=style&index=0&id=c395077a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c395077a",
  null
  
)

export default component.exports